import type { Input } from '@builder.io/sdk';

const FooterNoteField = [
  {
    name: 'content',
    type: 'richText',
  },
] as const satisfies DeepReadonly<Input[]>;

const FooterNoteConfig = {
  name: 'Footer Notes',
  inputs: FooterNoteField,
};

export type FooterNoteProps = GenerateBuilder<typeof FooterNoteConfig>;

export default FooterNoteConfig;
